import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import TopNav from 'components/topNav.js';
import ClearIcon from '@material-ui/icons/Clear';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import CommonFns from 'functions/common.ts';

function InvoiceList(props) {
  const Config = {
    purchase: {
      apiPath: '/vInvoiceOrder/list',
      countApi: '/vInvoiceOrder/count',
      orderProperty: 'createTime',
      countTransform: (data, self) => {
        let { 7: b, 5: c } = data;
        setCount([undefined, b, c]);
      },
      companyNameKey: 'innerVendorName',
      arrEnumField: [
        { mainKey: 'B02_Inv_Status', subKey: 'status', value: 'statusName' }
      ],
      detailLink: '/mp/purchase/billing/invoice/detail',
      searchBarPlaceholder: '通知单号、供应商名称、发票号码',
      tabs: ['全部', '退回', '待确认'],
      tabConfig: [
        [], //全部
        [7], //退回
        [5] //待确认
      ]
    },
    sale: {
      apiPath: '/invoiceOrder/list',
      countApi: '/invoiceOrder/count',
      orderProperty: 'createTime',
      countTransform: (data, self) => {
        let { 7: b, 5: c } = data;
        setCount([undefined, b, c]);
      },
      companyNameKey: 'customerPrintName',
      arrEnumField: [
        { mainKey: 'B02_Inv_Status', subKey: 'status', value: 'statusName' }
      ],
      detailLink: '/mp/sale/billing/invoice/detail',
      searchBarPlaceholder: '通知单号、客户名称、发票号码',
      tabs: ['全部', '退回', '待确认'],
      tabConfig: [
        [], //全部
        [7], //退回
        [5] //待确认
      ]
    }
  };

  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    decimalPlace,
    list,
    count,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    handleReset,
    self
  } = useList(props, config);

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
  }, [companyCode, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, self]);

  self.beforeSearch = async function () {
    // if (self.isPurchase) {
    self.searchQueries = {
      status: config.tabConfig[currentTab]
    };
    // }
  };

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
              {searchKey && (
                <div className="searchKeyBox">
                  查询信息：
                  <div onClick={handleClear}>
                    <span className="singleOmission">{searchKey}</span>
                    <ClearIcon
                      className="verticalMiddle"
                      color="primary"
                      fontSize="inherit"
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="list-total">{total}</div>
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <Link
                      to={`${config.detailLink}/${companyCode}/${item.invXkNo}`}
                      key={index}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>{item.invXkNo}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass('invoice', item.status)
                            }
                          >
                            {item.statusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        {self.isPurchase && (
                          <li>
                            <label>供应商</label>
                            <div>
                              {item.innerVendorName}({item.innerVendorCode})
                            </div>
                          </li>
                        )}
                        {!self.isPurchase && (
                          <li>
                            <label>客户</label>
                            <div>
                              {item.innerCustomerName}({item.innerCustomerCode})
                            </div>
                          </li>
                        )}
                        <li>
                          <label>发布日期</label>
                          <div>{formatDate(item.publishTime)}</div>
                        </li>
                        <li>
                          <label>发票金额</label>
                          <div>
                            {formatNumber(
                              item.totalAmount,
                              item.Amount_Decimal_Place
                            )}
                          </div>
                        </li>
                      </ul>
                    </Link>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

InvoiceList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(InvoiceList);
